import { EKeymapShortcutsPerMedia } from "../../components/broadcast/view-models/broadcast-preset.view-model";
import { MillisecondsToFormattedDuration } from "../common/ui-utils";
import { assetBlockItemExtendedData } from "./asset-block-item-extended-data";
import { ESwitcherAssetType } from "./switcher-item.type.enum";

export class SwitcherItem {
  constructor(
    public uid: string,
    public type: ESwitcherAssetType,
    public index: number,
    public assetName: string,
    public previewUrl: string,
    public assetId: string | number,
    public somMs: number,
    public durationMs: number,
    public volumeEnabled: boolean,
    public isProgram: boolean,
    public isPreview: boolean,
    public data: object = {},
    public colSpan: number = 1,
    public rowSpan: number = 1,
  ) {}
  public get formattedDuration(): string {
    return this.durationMs
      ? MillisecondsToFormattedDuration(this.durationMs)
      : "";
  }
  public get formattedSOM(): string {
    return this.somMs ? MillisecondsToFormattedDuration(this.somMs) : "";
  }
  public static createEmptyItem(uid: string, index: number): SwitcherItem {
    return new SwitcherItem(
      uid,
      ESwitcherAssetType.Empty,
      index,
      "",
      "",
      "",
      0,
      0,
      false,
      false,
      false,
    );
  }

  public clone(): SwitcherItem {
    return new SwitcherItem(
      this.uid,
      this.type,
      this.index,
      this.assetName,
      this.previewUrl,
      this.assetId,
      this.somMs,
      this.durationMs,
      this.volumeEnabled,
      this.isProgram,
      this.isPreview,
      this.data,
      this.colSpan,
      this.rowSpan,
    );
  }
}
